export const siteConfig = {
  name: "向日葵视频",
  tagline: "水果植物视频平台大全",
  description: "向日葵视频汇聚香蕉视频、西瓜视频免费等水果植物类视频平台，提供高清免费在线观看，涵盖蜜桃视频、樱花视频等水果视频在线资源，不缓冲流畅体验。",
  url: "https://www.xiangrikui.com",
  logo: "🌻",
};

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "视频分类", href: "/category/all" },
  { label: "热门文章", href: "/article/guide-intro" },
  { label: "关于我们", href: "/about" },
];

export const categories = [
  { slug: "all", name: "全部视频", icon: "ri-apps-line", description: "浏览所有水果植物视频内容" },
  { slug: "banana", name: "香蕉视频", icon: "ri-emotion-line", description: "香蕉相关的水果知识、种植与美食视频" },
  { slug: "watermelon", name: "西瓜视频", icon: "ri-contrast-drop-2-line", description: "西瓜种植、挑选技巧与夏日美食视频" },
  { slug: "peach", name: "蜜桃视频", icon: "ri-heart-line", description: "蜜桃种植、品种介绍与甜品制作视频" },
  { slug: "cherry", name: "樱花视频", icon: "ri-flower-line", description: "樱花观赏、摄影与花卉知识视频" },
  { slug: "grape", name: "葡萄视频", icon: "ri-bubble-chart-line", description: "葡萄种植、酿酒与品种科普视频" },
  { slug: "apple", name: "苹果视频", icon: "ri-shining-line", description: "苹果种植技术、品种与营养价值视频" },
  { slug: "mango", name: "芒果视频", icon: "ri-sun-line", description: "芒果品种、热带水果种植与美食视频" },
];

export const featuredVideos = [
  {
    id: "v1",
    title: "香蕉种植全过程实录：从幼苗到收获的180天",
    category: "banana",
    thumbnail: "https://readdy.ai/api/search-image?query=Beautiful%20banana%20plantation%20with%20ripe%20yellow%20bananas%20hanging%20from%20trees%20under%20warm%20sunlight%2C%20lush%20green%20leaves%2C%20tropical%20farm%20scene%2C%20bright%20and%20vibrant%20colors%2C%20cinematic%20wide%20shot%2C%20soft%20natural%20lighting%2C%20professional%20agricultural%20photography&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    duration: "18:24",
    views: "12.8万",
    date: "2026-07-28",
    description: "跟随镜头走进热带香蕉种植园，完整记录香蕉从幼苗培育到成熟采摘的全过程。",
  },
  {
    id: "v2",
    title: "夏日西瓜挑选秘籍：教你三招选出最甜西瓜",
    category: "watermelon",
    thumbnail: "https://readdy.ai/api/search-image?query=Fresh%20ripe%20watermelon%20sliced%20open%20on%20wooden%20table%20with%20red%20juicy%20flesh%2C%20green%20rind%2C%20summer%20picnic%20vibe%2C%20bright%20natural%20sunlight%2C%20food%20photography%20style%2C%20vibrant%20colors%2C%20clean%20composition&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    duration: "08:56",
    views: "28.3万",
    date: "2026-07-25",
    description: "资深果农亲授挑选西瓜的三大秘诀，让你每次都能买到最甜最脆的西瓜。",
  },
  {
    id: "v3",
    title: "蜜桃成熟时：探访中国最美桃园基地",
    category: "peach",
    thumbnail: "https://readdy.ai/api/search-image?query=Ripe%20juicy%20peaches%20hanging%20on%20tree%20branches%20in%20a%20beautiful%20orchard%2C%20pink%20and%20golden%20colors%2C%20warm%20summer%20sunlight%20filtering%20through%20leaves%2C%20idyllic%20farm%20scene%2C%20cinematic%20photography%2C%20soft%20bokeh%20background&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    duration: "15:42",
    views: "18.6万",
    date: "2026-07-22",
    description: "深入中国水蜜桃之乡，探访万亩桃园基地，了解蜜桃种植的奥秘。",
  },
  {
    id: "v4",
    title: "樱花季限定：日本赏樱胜地完全攻略",
    category: "cherry",
    thumbnail: "https://readdy.ai/api/search-image?query=Beautiful%20cherry%20blossom%20trees%20in%20full%20bloom%20along%20a%20peaceful%20path%2C%20soft%20pink%20petals%20falling%2C%20spring%20season%2C%20dreamy%20atmosphere%2C%20cinematic%20landscape%20photography%2C%20warm%20golden%20hour%20light&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    duration: "22:15",
    views: "35.1万",
    date: "2026-07-20",
    description: "从东京到京都，带你走遍日本十大赏樱胜地，感受樱花绽放的绝美瞬间。",
  },
  {
    id: "v5",
    title: "葡萄园的秘密：从种植到酿酒的完整旅程",
    category: "grape",
    thumbnail: "https://readdy.ai/api/search-image?query=Lush%20green%20grape%20vineyard%20with%20ripe%20purple%20grape%20clusters%20hanging%2C%20rolling%20hills%20in%20background%2C%20golden%20sunset%20light%2C%20wine%20country%20aesthetic%2C%20cinematic%20wide%20angle%2C%20professional%20agricultural%20photography&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    duration: "20:38",
    views: "9.7万",
    date: "2026-07-18",
    description: "走进法国波尔多葡萄酒庄园，揭秘从葡萄种植到美酒酿造的全流程。",
  },
  {
    id: "v6",
    title: "苹果的分类学：世界上最好吃的十大苹果品种",
    category: "apple",
    thumbnail: "https://readdy.ai/api/search-image?query=Various%20colorful%20fresh%20apple%20varieties%20arranged%20beautifully%20on%20rustic%20wooden%20surface%2C%20red%20green%20yellow%20apples%2C%20natural%20window%20light%2C%20food%20photography%2C%20clean%20minimal%20composition%2C%20high%20detail&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    duration: "12:50",
    views: "15.4万",
    date: "2026-07-15",
    description: "从红富士到嘎啦果，为你盘点全球十大苹果品种的口感和特点。",
  },
];

export const popularArticles = [
  {
    id: "a1",
    slug: "banana-nutrition-guide",
    title: "香蕉的营养价值全解析：为什么它是运动后的最佳水果",
    category: "banana",
    coverImage: "https://readdy.ai/api/search-image?query=Fresh%20yellow%20bananas%20on%20a%20clean%20white%20marble%20surface%20with%20soft%20morning%20light%2C%20minimalist%20food%20photography%2C%20one%20banana%20peeled%2C%20elegant%20composition%2C%20warm%20natural%20tones&width=800&height=500&seq=article-cover-01&orientation=landscape",
    excerpt: "香蕉富含钾、维生素B6和膳食纤维，是运动员补充能量的理想选择。本文将全面解析香蕉的营养成分及其对人体健康的多种益处。",
    date: "2026-07-30",
    readTime: "8分钟",
    views: "5.2万",
  },
  {
    id: "a2",
    slug: "watermelon-summer-health",
    title: "夏季吃西瓜的五大健康好处，最后一条你可能不知道",
    category: "watermelon",
    coverImage: "https://readdy.ai/api/search-image?query=Refreshing%20watermelon%20slices%20on%20a%20summer%20outdoor%20setting%2C%20bright%20sunlight%2C%20green%20grass%20background%2C%20cool%20summer%20vibes%2C%20food%20photography%2C%20vibrant%20red%20and%20green%20contrast&width=800&height=500&seq=article-cover-02&orientation=landscape",
    excerpt: "西瓜不仅解渴消暑，还富含番茄红素和瓜氨酸，对心血管健康大有裨益。一起来了解西瓜的隐藏健康价值。",
    date: "2026-07-28",
    readTime: "6分钟",
    views: "8.7万",
  },
  {
    id: "a3",
    slug: "peach-varieties-guide",
    title: "蜜桃品种大百科：黄桃、白桃、水蜜桃有什么区别",
    category: "peach",
    coverImage: "https://readdy.ai/api/search-image?query=Three%20different%20varieties%20of%20fresh%20ripe%20peaches%20arranged%20on%20a%20ceramic%20plate%2C%20yellow%20peach%20white%20peach%20and%20honey%20peach%2C%20soft%20natural%20lighting%2C%20elegant%20food%20photography%2C%20warm%20color%20palette&width=800&height=500&seq=article-cover-03&orientation=landscape",
    excerpt: "黄桃、白桃、水蜜桃、蟠桃……蜜桃家族成员众多，每种都有独特的风味和最佳食用方式。本文为你一一详解。",
    date: "2026-07-25",
    readTime: "10分钟",
    views: "6.3万",
  },
  {
    id: "a4",
    slug: "cherry-blossom-culture",
    title: "樱花的文化之旅：从东方美到世界风潮",
    category: "cherry",
    coverImage: "https://readdy.ai/api/search-image?query=Ancient%20Japanese%20temple%20with%20beautiful%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20traditional%20architecture%2C%20spring%20season%2C%20cultural%20heritage%20scene%2C%20soft%20pink%20petals%2C%20peaceful%20atmosphere%2C%20cinematic%20lighting&width=800&height=500&seq=article-cover-04&orientation=landscape",
    excerpt: "樱花不仅是日本的国花，更在全球范围内掀起了一股赏樱热潮。追溯樱花文化的起源与发展。",
    date: "2026-07-22",
    readTime: "12分钟",
    views: "11.5万",
  },
  {
    id: "a5",
    slug: "home-gardening-tips",
    title: "家庭园艺入门指南：阳台上也能种出美味水果",
    category: "apple",
    coverImage: "https://readdy.ai/api/search-image?query=Beautiful%20home%20balcony%20garden%20with%20potted%20fruit%20plants%20and%20herbs%2C%20small%20urban%20gardening%20space%2C%20warm%20sunlight%2C%20cozy%20atmosphere%2C%20lifestyle%20photography%2C%20green%20and%20natural%20colors&width=800&height=500&seq=article-cover-05&orientation=landscape",
    excerpt: "没有院子也能种水果！教你如何在阳台或露台上打造一个迷你果园，轻松享受自种水果的乐趣。",
    date: "2026-07-20",
    readTime: "15分钟",
    views: "19.8万",
  },
  {
    id: "a6",
    slug: "tropical-fruit-world",
    title: "热带水果大赏：芒果、榴莲、山竹的奇妙世界",
    category: "mango",
    coverImage: "https://readdy.ai/api/search-image?query=Colorful%20assortment%20of%20exotic%20tropical%20fruits%20including%20mango%20durian%20and%20mangosteen%20on%20a%20tropical%20leaf%20background%2C%20vibrant%20colors%2C%20fresh%20and%20juicy%2C%20food%20photography%2C%20bright%20natural%20light&width=800&height=500&seq=article-cover-06&orientation=landscape",
    excerpt: "热带地区孕育了世界上最奇特、最美味的水果。跟随我们一起探索这些来自热带的味觉奇迹。",
    date: "2026-07-18",
    readTime: "14分钟",
    views: "7.6万",
  },
];

export const faqItems = [
  {
    question: "向日葵视频是什么平台？",
    answer: "向日葵视频是一个专注于水果和植物类视频内容的综合性在线平台，汇集香蕉视频、西瓜视频、蜜桃视频、樱花视频等各类水果植物相关的高清视频资源，为用户提供流畅的在线观看体验。",
  },
  {
    question: "平台上的视频可以免费观看吗？",
    answer: "是的，向日葵视频平台上的所有视频内容均免费提供在线观看，无需注册或付费。我们致力于让更多人轻松获取水果植物相关的知识科普和精彩内容。",
  },
  {
    question: "视频播放卡顿怎么办？",
    answer: "我们采用了先进的视频分发技术，确保流畅的播放体验。如果您遇到卡顿，建议检查网络连接或尝试切换视频清晰度。大多数视频支持高清和标清两种模式。",
  },
  {
    question: "如何找到我感兴趣的水果视频？",
    answer: "您可以通过首页的分类导航，按水果类型浏览视频内容。目前我们提供香蕉视频、西瓜视频、蜜桃视频、樱花视频、葡萄视频、苹果视频、芒果视频等多个分类频道。",
  },
  {
    question: "平台上可以上传自己的视频吗？",
    answer: "目前平台内容由专业团队精选和制作，暂不支持用户自行上传视频。我们正在积极开发创作者入驻功能，敬请期待。",
  },
  {
    question: "如何在手机上看视频？",
    answer: "向日葵视频采用响应式设计，完美适配手机、平板和电脑等各类设备。您只需在浏览器中打开我们的网站，即可随时随地畅享高清视频内容。",
  },
];

export const stats = [
  { label: "视频总量", value: "10,000+" },
  { label: "内容分类", value: "15+" },
  { label: "日均观看", value: "50万+" },
  { label: "注册用户", value: "200万+" },
];